import { RelocationOrderStatus } from "@/api-schema-enums";
import { RELOCATION_ORDER_STATUS_TRANSLATIONS } from "@/components/relocation-order/relocation-order-status-translations";
import { BaseFilterProps, Filter, FilterData } from "../_types";
import { FilterComponent } from "../base-filter";

export const RELOCATION_ORDER_STATUS_FILTER_OPTIONS: Record<
  RelocationOrderStatus,
  { id: RelocationOrderStatus; name: string }
> = {
  Transport_Company_Awaiting_Pickup_Date: {
    id: RelocationOrderStatus.TransportCompanyAwaitingPickupDate,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Transport_Company_Awaiting_Pickup_Date,
  },
  Transport_Company_Awaiting_Ready_For_Transport: {
    id: RelocationOrderStatus.TransportCompanyAwaitingReadyForTransport,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Transport_Company_Awaiting_Ready_For_Transport,
  },
  Branch_Awaiting_Pickup: {
    id: RelocationOrderStatus.BranchAwaitingPickup,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Branch_Awaiting_Pickup,
  },
  Transport_Company_Rejected_Damaged_Vehicle: {
    id: RelocationOrderStatus.TransportCompanyRejectedDamagedVehicle,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Transport_Company_Rejected_Damaged_Vehicle,
  },
  Transport_Company_Rejected_Missing_Keys: {
    id: RelocationOrderStatus.TransportCompanyRejectedMissingKeys,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Transport_Company_Rejected_Missing_Keys,
  },
  Transport_Company_Rejected_Missing_Vehicle: {
    id: RelocationOrderStatus.TransportCompanyRejectedMissingVehicle,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Transport_Company_Rejected_Missing_Vehicle,
  },
  Transport_Company_In_Transit: {
    id: RelocationOrderStatus.TransportCompanyInTransit,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Transport_Company_In_Transit,
  },
  Transport_Company_Awaiting_Delivery_Acceptance: {
    id: RelocationOrderStatus.TransportCompanyAwaitingDeliveryAcceptance,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Transport_Company_Awaiting_Delivery_Acceptance,
  },
  Branch_Rejected_Damaged_Vehicle: {
    id: RelocationOrderStatus.BranchRejectedDamagedVehicle,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Branch_Rejected_Damaged_Vehicle,
  },
  Branch_Rejected_Missing_Keys: {
    id: RelocationOrderStatus.BranchRejectedMissingKeys,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Branch_Rejected_Missing_Keys,
  },
  Branch_Rejected_Missing_Vehicle: {
    id: RelocationOrderStatus.BranchRejectedMissingVehicle,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Branch_Rejected_Missing_Vehicle,
  },
  Branch_Rejected_Wrong_Vehicle: {
    id: RelocationOrderStatus.BranchRejectedWrongVehicle,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Branch_Rejected_Wrong_Vehicle,
  },
  Transport_Company_Rest_At_Layover: {
    id: RelocationOrderStatus.TransportCompanyRestAtLayover,
    name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Transport_Company_Rest_At_Layover,
  },
  Completed: { id: RelocationOrderStatus.Completed, name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Completed },
  Cancelled: { id: RelocationOrderStatus.Cancelled, name: RELOCATION_ORDER_STATUS_TRANSLATIONS.Cancelled },
};

export class RelocationOrderStatusFilter extends Filter<unknown, unknown> {
  constructor(options?: { id: RelocationOrderStatus; name: string }[], { id }: { id?: string } = {}) {
    super();
    this.options = options ?? Object.values(RELOCATION_ORDER_STATUS_FILTER_OPTIONS);
    if (id) this.id = id;
  }

  readonly id: string = "status";
  readonly labelSingular = "common:Status";
  readonly labelPlural = "common:Status";
  readonly placeholder = "common:SelectStatus";
  readonly searchPlaceholder = "common:SearchStatus";
  readonly emptyText = "common:NoStatusFound";

  options: { id: RelocationOrderStatus; name: string }[] = [];

  getData(): FilterData {
    return {
      options: this.options,
      isLoading: false,
      error: null,
    };
  }

  render(props: BaseFilterProps) {
    return <FilterComponent filter={this} {...props} />;
  }
}
